"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var number_1 = require("./utils/number");
var object_1 = require("./utils/object");
function freshContext(ctx, callback) {
    ctx.save();
    callback();
    ctx.restore();
}
function clear(ctx, colour) {
    if (!colour) {
        ctx.clearRect(0, 0, ctx.canvas.width, ctx.canvas.height);
    }
    else {
        rect(ctx, { x: 0, y: 0, width: ctx.canvas.width, height: ctx.canvas.height }, {
            fill: { colour: colour },
            line: { width: 0 }
        });
    }
}
function clearRect(ctx, rectangle, colour) {
    if (!colour) {
        ctx.clearRect(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
    }
    else {
        rect(ctx, rectangle, {
            fill: { colour: colour },
            line: { width: 0 }
        });
    }
}
function square(ctx, position, size, options) {
    if (options === void 0) { options = defaultRect; }
    rect(ctx, { x: position.x, y: position.y, width: size, height: size }, options);
}
var defaultRect = {
    fill: {
        colour: '#000000',
        opacity: 1
    },
    line: {
        width: 1,
        colour: '#FFFFFF',
        opacity: 1
    }
};
function rect(ctx, rectangle, options) {
    if (options === void 0) { options = defaultRect; }
    freshContext(ctx, function () {
        options = (0, object_1.merge)(defaultRect, options);
        ctx.globalAlpha = options.fill.opacity;
        ctx.fillStyle = options.fill.colour;
        ctx.fillRect(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
        ctx.globalAlpha = 1;
        if (options.line.width !== 0) {
            ctx.globalAlpha = options.line.opacity;
            ctx.strokeStyle = options.line.colour;
            ctx.lineWidth = options.line.width;
            ctx.strokeRect(rectangle.x, rectangle.y, rectangle.width, rectangle.height);
            ctx.globalAlpha = 1;
        }
    });
}
var defaultLine = {
    width: 1,
    colour: '#FFFFFF',
    opacity: 1
};
function line(ctx, from, to, options) {
    if (options === void 0) { options = defaultLine; }
    freshContext(ctx, function () {
        options = (0, object_1.merge)(defaultLine, options);
        ctx.globalAlpha = options.opacity;
        ctx.strokeStyle = options.colour;
        ctx.lineWidth = options.width;
        ctx.beginPath();
        ctx.moveTo(from.x, from.y);
        ctx.lineTo(to.x, to.y);
        ctx.stroke();
        ctx.globalAlpha = 1;
        ctx.closePath();
    });
}
function bezier(ctx, from, to, cp1, cp2, options) {
    if (options === void 0) { options = defaultLine; }
    freshContext(ctx, function () {
        options = (0, object_1.merge)(defaultLine, options);
        ctx.globalAlpha = options.opacity;
        ctx.strokeStyle = options.colour;
        ctx.lineWidth = options.width;
        ctx.beginPath();
        ctx.moveTo(from.x, from.y);
        ctx.bezierCurveTo(cp1.x, cp1.y, cp2.x, cp2.y, to.x, to.y);
        ctx.stroke();
        ctx.globalAlpha = 1;
        ctx.closePath();
    });
}
function quadratic(ctx, from, to, cp, options) {
    if (options === void 0) { options = defaultLine; }
    freshContext(ctx, function () {
        options = (0, object_1.merge)(defaultLine, options);
        ctx.globalAlpha = options.opacity;
        ctx.strokeStyle = options.colour;
        ctx.lineWidth = options.width;
        ctx.beginPath();
        ctx.moveTo(from.x, from.y);
        ctx.quadraticCurveTo(cp.x, cp.y, to.x, to.y);
        ctx.stroke();
        ctx.globalAlpha = 1;
        ctx.closePath();
    });
}
function curve(ctx, from, to, controlPoints, options) {
    if (options === void 0) { options = defaultLine; }
    if (controlPoints.cp1 && controlPoints.cp2) {
        bezier(ctx, from, to, controlPoints.cp1, controlPoints.cp2, options);
    }
    else if (controlPoints.cp1 && !controlPoints.cp2) {
        quadratic(ctx, from, to, controlPoints.cp1, options);
    }
    else {
        line(ctx, from, to, options);
    }
}
var defaultCircle = {
    fill: {
        colour: '#000000',
        opacity: 1
    },
    line: {
        colour: '#FFFFFF',
        opacity: 1,
        width: 1
    }
};
function circle(ctx, position, radius, options) {
    if (options === void 0) { options = defaultCircle; }
    freshContext(ctx, function () {
        options = (0, object_1.merge)(defaultCircle, options);
        ctx.globalAlpha = options.fill.opacity;
        ctx.fillStyle = options.fill.colour;
        ctx.beginPath();
        ctx.arc(position.x, position.y, radius, 0, 2 * Math.PI);
        ctx.closePath();
        ctx.fill();
        ctx.globalAlpha = 1;
        if (options.line.width !== 0) {
            ctx.globalAlpha = options.line.opacity;
            ctx.strokeStyle = options.line.colour;
            ctx.lineWidth = options.line.width;
            ctx.beginPath();
            ctx.arc(position.x, position.y, radius, 0, 2 * Math.PI);
            ctx.closePath();
            ctx.stroke();
        }
    });
}
function image(ctx, image, position, size) {
    if (size) {
        ctx.drawImage(image, position.x, position.y, size.width, size.height);
    }
    else {
        ctx.drawImage(image, position.x, position.y, image.width, image.height);
    }
}
function subImage(ctx, image, position, size, subPosition, subSize) {
    ctx.drawImage(image, subPosition.x, subPosition.y, subSize.width, subSize.height, position.x, position.y, size.width, size.height);
}
function sprite(ctx, sprite) {
    freshContext(ctx, function () {
        var halfWidth = sprite.size.width / 2;
        var halfHeight = sprite.size.height / 2;
        ctx.translate(sprite.position.x + halfWidth, sprite.position.y + halfHeight);
        ctx.rotate(number_1.default.toRadians(sprite.rotation));
        if (sprite.frames.length > 1) {
            subImage(ctx, sprite.texture, {
                x: -halfWidth,
                y: -halfHeight
            }, {
                width: sprite.size.width,
                height: sprite.size.height
            }, {
                x: sprite.frames[sprite.frame].position.x,
                y: sprite.frames[sprite.frame].position.y
            }, {
                width: sprite.frames[sprite.frame].size.width,
                height: sprite.frames[sprite.frame].size.height
            });
        }
        else {
            image(ctx, sprite.texture, {
                x: -halfWidth,
                y: -halfHeight
            }, {
                width: sprite.size.width,
                height: sprite.size.height
            });
        }
    });
}
function txt(ctx, position, text, colour, font) {
    if (text === void 0) { text = ''; }
    if (colour === void 0) { colour = '#000000'; }
    if (font === void 0) { font = '16pt sans-serif'; }
    freshContext(ctx, function () {
        ctx.fillStyle = colour;
        ctx.font = font;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'top';
        ctx.fillText(text, position.x, position.y);
    });
}
function tile(ctx, position, tilesheet, gridPosition, tilesheetPosition, scale, tileSize) {
    subImage(ctx, tilesheet, {
        x: position.x + scale * (gridPosition.x * tileSize.width),
        y: position.y + scale * (gridPosition.y * tileSize.height)
    }, {
        width: scale * tileSize.width,
        height: scale * tileSize.height
    }, {
        x: tileSize.width * tilesheetPosition.x,
        y: tileSize.height * tilesheetPosition.y
    }, {
        width: tileSize.width,
        height: tileSize.height
    });
}
// tilegrid: a 2d array of numbers representing terrain types
// spritesheets: An object, each key is the value that represents a tile from this sheet
function tiles(ctx, position, tileGrid, spriteSheets, scale) {
    var dirValues = {
        NW: 1,
        N: 2,
        NE: 4,
        E: 8,
        SE: 16,
        S: 32,
        SW: 64,
        W: 128
    };
    var _loop_1 = function (y) {
        var _loop_2 = function (x) {
            if (tileGrid[y][x] === 0) {
                return "continue";
            }
            // REAL VALUES
            var tl = y > 0 ? tileGrid[y - 1][x - 1] : 0;
            var tm = y > 0 ? tileGrid[y - 1][x] : 0;
            var tr = y > 0 ? tileGrid[y - 1][x + 1] : 0;
            var ml = tileGrid[y][x - 1];
            var m = tileGrid[y][x];
            var mr = tileGrid[y][x + 1];
            var bl = y < tileGrid.length - 1 ? tileGrid[y + 1][x - 1] : 0;
            var bm = y < tileGrid.length - 1 ? tileGrid[y + 1][x] : 0;
            var br = y < tileGrid.length - 1 ? tileGrid[y + 1][x + 1] : 0;
            // BINARY VALUES
            var n = m === tm ? 1 : 0;
            var e = m === mr ? 1 : 0;
            var s = m === bm ? 1 : 0;
            var w = m === ml ? 1 : 0;
            var nw = m === tm && m === ml ? (m === tl ? 1 : 0) : 0;
            var ne = m === tm && m === mr ? (m === tr ? 1 : 0) : 0;
            var sw = m === bm && m === ml ? (m === bl ? 1 : 0) : 0;
            var se = m === bm && m === mr ? (m === br ? 1 : 0) : 0;
            var sum = dirValues.NW * nw +
                dirValues.N * n +
                dirValues.NE * ne +
                dirValues.E * e +
                dirValues.SE * se +
                dirValues.S * s +
                dirValues.SW * sw +
                dirValues.W * w;
            // Figure out which sheet we're supposed to be drawing from
            var sheet = spriteSheets.filter(function (sheet) {
                return sheet.type === tileGrid[y][x];
            })[0];
            if (!sheet) {
                console.error("Sheet ".concat(tileGrid[y][x], " not found!"));
                return { value: void 0 };
            }
            var selections = sheet.tiles.filter(function (x) { return x.type === sum; });
            // Note: Just picking a random one of the variants every time we render for now
            var selection = selections[Math.floor(Math.random() * selections.length)];
            if (selection) {
                tile(ctx, position, sheet.image, { x: x, y: y }, selection.position, scale, selection.size);
            }
            else {
                console.error("Tile not defined ".concat(sum));
            }
        };
        for (var x = 0; x < tileGrid[y].length; x++) {
            var state_2 = _loop_2(x);
            if (typeof state_2 === "object")
                return state_2;
        }
    };
    for (var y = 0; y < tileGrid.length; y++) {
        var state_1 = _loop_1(y);
        if (typeof state_1 === "object")
            return state_1.value;
    }
}
var defaultDropShadow = {
    shadowcolour: '#000000',
    shadowBlur: 6,
    shadowOffsetX: 4,
    shadowOffsetY: 4
};
function shadow(ctx, drawingOperations, options) {
    if (options === void 0) { options = defaultDropShadow; }
    freshContext(ctx, function () {
        options = (0, object_1.merge)(defaultDropShadow, options);
        ctx.shadowColor = options.shadowcolour;
        ctx.shadowBlur = options.shadowBlur;
        ctx.shadowOffsetX = options.shadowOffsetX;
        ctx.shadowOffsetY = options.shadowOffsetY;
        drawingOperations();
    });
}
function dodge(ctx, drawingOperations) {
    freshContext(ctx, function () {
        ctx.globalCompositeOperation = 'color-dodge';
        drawingOperations();
    });
}
function overlay(ctx, drawingOperations) {
    freshContext(ctx, function () {
        ctx.globalCompositeOperation = 'overlay';
        drawingOperations();
    });
}
function rotation(ctx, drawingOperations, rotation, around) {
    freshContext(ctx, function () {
        ctx.translate(around.x, around.y);
        console.log('rotate', rotation, number_1.default.toRadians(rotation));
        ctx.rotate(number_1.default.toRadians(rotation));
        ctx.translate(-around.x, -around.y);
        drawingOperations();
    });
}
function transparency(ctx, drawingOperations, alpha) {
    if (alpha === void 0) { alpha = 0.25; }
    freshContext(ctx, function () {
        ctx.globalAlpha = alpha;
        drawingOperations();
    });
}
function create(ctx) {
    return {
        circle: function (position, radius, options) {
            if (options === void 0) { options = defaultCircle; }
            circle(ctx, position, radius, options);
        },
        clear: function (colour) {
            clear(ctx, colour);
        },
        clearRect: function (rectangle, colour) {
            clearRect(ctx, rectangle, colour);
        },
        curve: function (from, to, controlPoints, options) {
            curve(ctx, from, to, controlPoints, options);
        },
        square: function (position, size, options) {
            if (options === void 0) { options = defaultRect; }
            square(ctx, position, size, options);
        },
        rect: function (rectangle, options) {
            if (options === void 0) { options = defaultRect; }
            rect(ctx, rectangle, options);
        },
        image: function (img, position, size) {
            image(ctx, img, position, size);
        },
        line: function (from, to, options) {
            if (options === void 0) { options = defaultLine; }
            line(ctx, from, to, options);
        },
        sprite: function (spr) {
            sprite(ctx, spr);
        },
        subImage: function (img, position, size, subPosition, subSize) {
            subImage(ctx, img, position, size, subPosition, subSize);
        },
        text: function (position, text, colour, font) {
            if (position === void 0) { position = { x: 0, y: 0 }; }
            if (text === void 0) { text = ''; }
            if (colour === void 0) { colour = '#000000'; }
            if (font === void 0) { font = '16pt sans-serif'; }
            txt(ctx, position, text, colour, font);
        },
        tiles: function (position, tileGrid, spriteSheets, scale) {
            tiles(ctx, position, tileGrid, spriteSheets, scale);
        },
        shadow: function (drawingOperations, options) {
            if (options === void 0) { options = defaultDropShadow; }
            shadow(ctx, drawingOperations, options);
        },
        dodge: function (drawingOperations) {
            dodge(ctx, drawingOperations);
        },
        overlay: function (drawingOperations) {
            overlay(ctx, drawingOperations);
        },
        transparency: function (drawingOperations, alpha) {
            if (alpha === void 0) { alpha = 0.25; }
            transparency(ctx, drawingOperations, alpha);
        },
        rotation: function (drawingOperations, rotateBy, around) {
            if (rotateBy === void 0) { rotateBy = 0; }
            if (around === void 0) { around = { x: 0, y: 0 }; }
            rotation(ctx, drawingOperations, rotateBy, around);
            // rotation()
        }
    };
}
exports.default = {
    circle: circle,
    clear: clear,
    clearRect: clearRect,
    create: create,
    curve: curve,
    dodge: dodge,
    image: image,
    line: line,
    overlay: overlay,
    rotation: rotation,
    rect: rect,
    shadow: shadow,
    sprite: sprite,
    square: square,
    subImage: subImage,
    text: txt,
    tiles: tiles,
    transparency: transparency
};
